import moment from "moment";

import { DevOpsRepositoryPlatform } from "./generated";

import type { TimeChargeModel } from "./generated";
export function createTimeCharge(): TimeChargeModel {
    return {
        taskId: 0,
        taskStatusId: 0,
        timeEntryType: null,
        userId: null,
        teamMemberName: "",
        clientId: undefined,
        projectId: undefined,
        date: moment(new Date()).toISOString(),
        hours: null,
        timeStart: moment(new Date()).format("HH:mm"),
        timeEnd: moment(new Date()).format("HH:mm"),
        id: 0,
        saveSuccessful: false,
        description: "",
        copyToTaskComment: true,
        timeChargeUserId: null,
        pullRequestNumber: null,
        gitHubRepository: "",
        devOpsProjectId: "",
        pullRequestLink: "",
        reassigned: false,
        repositoryPlatform: DevOpsRepositoryPlatform
    };
}
